import { render } from "./ExpertMode.vue?vue&type=template&id=317a3822&scoped=true"
import script from "./ExpertMode.vue?vue&type=script&lang=js"
export * from "./ExpertMode.vue?vue&type=script&lang=js"

import "./ExpertMode.vue?vue&type=style&index=0&id=317a3822&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317a3822"]])

export default __exports__